import { render, staticRenderFns } from "./PackageViewAuthorizations.vue?vue&type=template&id=46c5f9ce"
import script from "./PackageViewAuthorizations.vue?vue&type=script&lang=js"
export * from "./PackageViewAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports